import vsComponent from './vsCol'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
